import React from 'react';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';

const ZipField = ({
  id = 'zipcode',
  name = 'zipcode',
  value,
  error,
  isTouched,
  handleBlur,
  handleChange,
  updateShipping,
  isRequired = true,
  ...props
}) => (
  <LabeledTextInput
    id={id}
    name={name}
    maxLength="5"
    label="Zip code *"
    data-xc="shipping-zip-field"
    onChange={evt => {
      if (/^\d{0,5}$/.test(evt.target.value) || evt.target.value === '') {
        handleChange(evt);
      }
    }}
    onBlur={evt => {
      handleBlur(evt);

      if (!error && updateShipping) {
        updateShipping();
      }
    }}
    value={value}
    autoComplete="postal-code"
    required={isRequired ? '' : undefined}
    aria-required={isRequired ? '' : undefined}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    errorMessage={isTouched && error ? error : null}
  />
);

ZipField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  id: PropTypes.string,
  isRequired: PropTypes.bool,
  isTouched: PropTypes.bool,
  name: PropTypes.string,
  updateShipping: PropTypes.func,
  value: PropTypes.string,
};

export default ZipField;
